import { css } from 'emotion';

import { colors, fonts } from '../styles';

const dropDownMenu = css`
  > li {
    text-align: center;

    span {
      font-size: ${fonts.weight.bold};
      line-height: 17px;

      :hover {
        color: ${colors.primary.default};
        transition: color 0.4s ease-in-out;
      }
    }
  }
`;

export default {
  dropDownMenu,
};
